import React, { useContext, useState } from 'react';
import { ResendConfirmation, PageContent } from './components';
import { AuthPath, AuthPageProps, PasswordProp } from './models';
import * as s from './styles';
import { UserContext } from './UserProvider';
import { useAuthForm, getTo, getExistingUserEnabledRedirect } from './utils';
import authClient from '../../api/authClient';
import { useTitle } from 'packages/smart-home-support/hooks';
import { usePartner } from 'packages/smart-home-support/partner';
import { NumericCodeField } from 'packages/smart-home-support/components/forms';
import { CONFIRMATION_CODE_LENGTH } from 'packages/smart-home-support/api/authClient/constants';
import RedirectWhenEnabled, { EnabledRedirect } from './components/RedirectWhenEnabled';
import { LinkId } from 'packages/smart-home-support/constants';

type SignupConfirmPageProps = AuthPageProps & PasswordProp;

const SignupConfirmPage: React.FC<SignupConfirmPageProps> = (props) => {
  useTitle('Verify Phone');
  const { user, setUser } = useContext(UserContext);

  const [, partnerController] = usePartner();
  const [code, setCode] = useState('');

  const [{ error, isLoading }, formController] = useAuthForm(async () => {
    const user = await authClient.confirmLoginPasswordless(code);
    partnerController.setProduct(user.productCode);
    setUser(user);
  });

  const redirects: EnabledRedirect[] = [
    getExistingUserEnabledRedirect(user),
    {
      enabled: !Boolean(props.mdn),
      to: getTo(AuthPath.Login),
    },
  ];

  return (
    <RedirectWhenEnabled redirects={redirects}>
      <PageContent
        isLoading={isLoading}
        heading="Let&rsquo;s verify it&rsquo;s you"
        content={
          <>
            Enter the {CONFIRMATION_CODE_LENGTH}-digit verification code we texted to{' '}
            <s.HeadingPhoneNumber>{props.mdn}</s.HeadingPhoneNumber>
          </>
        }
      >
        <s.SignupForm onSubmit={formController.submit}>
          <NumericCodeField
            name="code"
            label={`${CONFIRMATION_CODE_LENGTH}-digit code`}
            maxLength={CONFIRMATION_CODE_LENGTH}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            formController={formController}
          />
          {error && <s.Error>{error.message}</s.Error>}
          <s.SubmitButton type="submit">Confirm</s.SubmitButton>
          <s.FormHelp>
            <ResendConfirmation mdn={props.mdn} />
            <br />
            Wrong number?{' '}
            <s.FormHelpLink
              id={LinkId.AuthVerifySecretGoBack}
              to={getTo(AuthPath.Login)}
              onClick={() => props.setMdn('')}
            >
              Go back
            </s.FormHelpLink>
          </s.FormHelp>
        </s.SignupForm>
      </PageContent>
    </RedirectWhenEnabled>
  );
};

export default SignupConfirmPage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/ConfirmPage.tsx